import { useState } from 'react';
import { GlobalButton, DateInput, TextInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { 
  DeleteForever as TrashIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useDateRangeValidator } from '@/hooks';
import { TimeUnit } from '@/hooks/useDateRangeValidator';
import { ServiceHistoryFilter } from '../models';

interface SearchBarProps {
  onSearch: (filters: ServiceHistoryFilter) => void;
  initialFilter: ServiceHistoryFilter;
}

export default function SearchBar({ onSearch, initialFilter }: SearchBarProps) {
  const [localFilter, setLocalFilter] = useState<ServiceHistoryFilter>(initialFilter);

  const { validate } = useDateRangeValidator();

  const validateDateRange = (dateFrom: Date, dateTo: Date) => {
    const { isValid, error } = validate(dateFrom, dateTo, {
      value: 31,
      unit: TimeUnit.days,
    });

    if (!isValid) {
      alert(error);
      return false;
    }
    
    return true;
  };

  const handleDateFromChange = (newValue: Date | null) => {
    if (newValue) {
      setLocalFilter((prev) => ({
        ...prev,
        dateFrom: new Date(newValue),
      }));
    }
  };

  const handleDateToChange = (newValue: Date | null) => {
    if (newValue) {
      setLocalFilter((prev) => ({
        ...prev,
        dateTo: new Date(newValue),
      }));
    }
  };

  const handleBarcodeChange = (value: string | number) => {
    setLocalFilter((prev) => ({
      ...prev,
      barcode: value.toString(),
    }));
  };

  const handleSearch = () => {
    if (!validateDateRange(localFilter.dateFrom!, localFilter.dateTo!)) {
      return;
    }
    onSearch(localFilter);
  };

  const resetFilter = () => {
    setLocalFilter(initialFilter);
    onSearch(initialFilter);
  };

  return (
    <div className="w-full flex flex-col justify-center gap-5 p-5 bg-white rounded-sm shadow-xl">
      <div className="flex gap-5 justify-end">
        <TextInput
          name='service-history-barcode-search'
          placeholder='Buscar por código de barras'
          value={localFilter.barcode || ''}
          onChange={handleBarcodeChange}
        />
        <DateInput
          name='service-history-date-from'
          placeholder='Fecha desde'
          value={localFilter.dateFrom!}
          onChange={handleDateFromChange}
        />
        <DateInput
          name='service-history-date-to'
          placeholder='Fecha hasta'
          value={localFilter.dateTo!}
          onChange={handleDateToChange}
        />
      </div>
      <div className="flex gap-2.5 justify-end">
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilter}
        >
          <TrashIcon color="primary" />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color="primary" />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
}
